import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

function Account() {
    const { t } = useTranslation();

    const userData = useSelector(state => state.organization.userData);
    const organizationData = useSelector(state => state.organization.organizationData);

    return (
        <>
            {Object.keys(userData).length > 0 && Object.keys(organizationData).length > 0 && (
                <Box className="box-settings">
                    <Box mb={3}>
                        <Typography variant="h6" mb={1}>{t('settings.account.account_and_email')}</Typography>
                        <Typography variant="body2">{userData.email}</Typography>
                    </Box>
                    <Box mb={3}>
                        <Typography variant="h6" mb={1}>{t('settings.account.name')}</Typography>
                        <Typography variant="body2">{userData.firstname}</Typography>
                    </Box>
                    <Box mb={3}>
                        <Typography variant="h6" mb={1}>{t('settings.account.account_type')}</Typography>
                        <Typography variant="body2">{t('settings.account.coursemos_integration')}</Typography>
                    </Box>
                    <Box mb={3}>
                        <Typography variant="h6" mb={1}>{t('settings.account.organization')}</Typography>
                        <Typography variant="body2">{organizationData.organization_name}</Typography>
                    </Box>
                    <Box mb={3}>
                        <Typography variant="h6" mb={1}>{t('settings.account.user_id')}</Typography>
                        <Typography variant="body2">{userData.userid}</Typography>
                    </Box>
                    <Box mb={3}>
                        <Typography variant="h6" mb={1}>{t('settings.account.device')}</Typography>
                        <Typography variant="body2">{`${navigator.userAgent}`}</Typography>
                    </Box>
                </Box>
            )}
        </>
    );
}

export default Account;